module.exports = __webpack_public_path__ + "static/bushido-3-5e581cbf5b9aa8a6825d422a34b6d423.png";